import React, { FC } from 'react';
import { BookingResource, BookingSlot } from '../../types/booking';
import { useUserBookings } from '../../hooks/useBookings';
import { UserBookingItem } from './UserBookingItem';
import { FormattedMessage } from 'react-intl';

interface Props {
  resources: BookingResource[];
  onBookingCancel: (booking: BookingSlot, resource: BookingResource) => void;
}

export const UserBookingsList: FC<Props> = ({ resources, onBookingCancel }) => {
  const { data: userBookings, isLoading } = useUserBookings(resources);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center p-8">
        <FormattedMessage defaultMessage="Laddar bokningar..." />
      </div>
    );
  }

  if (!userBookings?.length) {
    return (
      <div className="flex justify-center items-center p-8 text-gray-500">
        <FormattedMessage defaultMessage="Inga bokningar hittades" />
      </div>
    );
  }

  return (
    <>
      {userBookings.map((booking) => {
        const resource = resources.find((r) => r.id === booking.resourceId);
        if (!resource) return null;

        return (
          <UserBookingItem
            key={`${booking.resourceId}_${booking.id}`}
            resource={resource}
            booking={booking}
            onCancel={(booking) => onBookingCancel(booking, resource)}
          />
        );
      })}
    </>
  );
};
